export default "__VITE_ASSET__BuoRWVPC__"